import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { isMobile } from "react-device-detect";
import { PlayerTroopType } from "../../types/troop";
import LargeView from "./TroopBox/LargeView";
import TinyView from "./TroopBox/TinyView";
import ItemsList from "./TroopBox/ItemsList";
import { TroopBoxProps } from "./TroopBox/types";

const TroopBox: React.FC<PlayerTroopType & TroopBoxProps> = (props) => {
  return (
    <SkeletonTheme enableAnimation={!isMobile} baseColor="#3e382b" highlightColor="#474132">
      {!props.type || props.type === 1 ? (
        <>
          <LargeView {...(props as any)} />
        </>
      ) : (
        <>
          <TinyView {...(props as any)} />
          <ItemsList className="mb-4" items={props.items as any} setBonuses={(props as any).setBonuses} />
        </>
      )}
    </SkeletonTheme>
  );
};

export default TroopBox;


